"use client";

import { Button, Input, Label, Card, CardContent, CardHeader, CardTitle } from "@aio/platform-ui";
import * as React from "react";
import { useBranding } from "./branding-provider";

export function BrandingSettingsForm() {
  const { hex, setHex } = useBranding();
  const [draft, setDraft] = React.useState(hex);

  return (
    <Card>
      <CardHeader>
        <CardTitle as="h2">Brand</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="brand-hex">Accent color</Label>
          <div className="flex items-center gap-3">
            <input
              id="brand-hex"
              type="color"
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              className="h-11 w-16 cursor-pointer rounded-md border border-border bg-bg p-1"
            />
            <Input
              aria-label="Accent color (hex)"
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              className="font-mono"
            />
            <Button onClick={() => setHex(draft)}>Apply</Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
